import { createRoot } from 'react-dom/client';
// Bundled instead of loaded from a CDN: one less render-blocking cross-origin request
import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// React 18 createRoot API
const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);

// Report Web Vitals to GA4
reportWebVitals((metric) => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', metric.name, {
      event_category: 'Web Vitals',
      event_label: metric.id,
      value: Math.round(metric.name === 'CLS' ? metric.value * 1000 : metric.value),
      non_interaction: true,
    });
  }
});

// Uncomment to enable service worker
// registerServiceWorker();
